// extracted by mini-css-extract-plugin
export default {"container":"Team_container__1-Fm-","wrapper":"Team_wrapper__mXFHT","team":"Team_team__UmYoS","member":"Team_member__5gLBx","socials":"Team_socials__6qvQn"};